import { Pagination, User, Voivodeship } from '@interfaces';

export interface Office {
  id?: string;
  name: string;
  addressStreet: string;
  addressExtraInfo: { [key: string]: string };
  recipientForPost?: { [key: string]: string };
  addressZipcode: string;
  addressCity: string;
  telephoneNumber: string;

  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date | null;

  assignedVoivodeships?: Partial<Voivodeship>[];
  assignedEmployees?: Partial<User>[];
}

export interface SearchOfficeOpts extends Pagination {
  voivodeshipsIds?: string[];
  showDeleted?: boolean;
}

export interface CreateOfficeOpts {
  name: string;
  addressStreet: string;
  addressExtraInfo: { [key: string]: string };
  recipientForPost?: { [key: string]: string };
  addressZipcode: string;
  addressCity: string;
  telephoneNumber: string;
}

export interface ToggleAssignedVoivodeship {
  officeId: string;
  voivodeshipId: string;
  assigned: boolean;
}

export interface getOfficeVisitsAvailabilityOpts {
  userProcessId: string;
  startAt: string;
  endAt: string;
}

export interface OfficeVisitsAvailability {
  active: boolean;
  date: string;
  dayOfWeek: number;
  hasSlots?: boolean;
  slots: OfficeVisitAvailabilitySlot[];
}

export interface OfficeVisitAvailabilitySlot {
  time: string;
  available: boolean;
  isNotAllowed?: boolean;
}

export interface OfficeVisitsSetting {
  id: string;
  officeId: string;
  dayOfWeek: number;
  active: boolean;
  startAt: string;
  endAt: string;
  hasLimit: boolean;
  limit: number;
}

export type UpdateOfficeVisitsSetting = {
  dayOfWeek: number;
  active: boolean;
  startAt: string | null;
  endAt: string | null;
  hasLimit: boolean;
  limit: number | null;
};
